export const ROOT = '/ApplicantStatusAPI';
export const LOGINROOT = '/PublicLoginScreenAPI'
export const STATUS = `${ROOT}/getapplicantstatus`;
export const COMPANY = `${LOGINROOT}/company`;
export const FAQ = `${LOGINROOT}/getfaqs`;